import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { addQueryParamsToUrl } from '../../Utils/utils';
import { updateComponentCTALink } from '../../Lib/redux/slices/components';
import { ComponentTypes } from '../../Data/Components';

/**
 * Anura is a tool that helps us to understand if a user is a bot or not.
 * It is loaded on the parent page, and the parent page will update all links on the parent page with anr and anrId query parameters.
 * This component is responsible for updating the links within the chameleon iframe i.e. the URL of each CPC card and supplier card with the anr and anrId query parameters.
 *
 * https://docs.anura.io/integration/callback-functions
 */
const AnuraManager = () => {
  const dispatch = useDispatch();
  const components = useSelector((store) => store.components);
  const anuraData = useSelector((store) => store.userIdentities.anuraData);

  useEffect(() => {
    if (!anuraData?.id || !anuraData?.status || !components) return;

    Object.entries(components || {}).forEach(([componentId, component]) => {
      if (component.component.type === ComponentTypes.SUPPLIER_CARD) {
        const { cta_link_url } = component.component.additionalSettings;
        if (cta_link_url) {
          const newUrl = addQueryParamsToUrl({
            url: cta_link_url,
            params: {
              anr: anuraData.status,
              anrid: anuraData.id,
            },
          });

          dispatch(
            updateComponentCTALink({
              componentId,
              newUrl,
            })
          );
        }
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [anuraData]);

  return null;
};

export default AnuraManager;
